import React from 'react'

function Partners({ content }) {
  const partners = content.partnerTiles.filter(org => {
    return org.type === 'PARTNER'
  })
  const support = content.partnerTiles.filter(org => {
    return org.type === 'SUPPORT'
  })
  return (
    <section id={'partners'}>
      <div className={'quasi-iso-mask-top'} />
      <div className={'midHeading midHeading--partners'}>
        <h2>{'Supported By'}</h2>
      </div>
      <TileGrid partners={support} />
      {partners.length === 0
        ? null
        : [
            <div className={'midHeading midHeading--partners'}>
              <h2>{'Our Partners'}</h2>
            </div>,
            <TileGrid partners={partners} />
          ]}
    </section>
  )
}

function TileGrid({ partners }) {
  const tiles = partners.map((partner, i) => {
    return <Tile key={`partner-${i}`} partner={partner} />
  })
  return <div className={'grid-list'}>{tiles}</div>
}

function Tile({ partner }) {
  if (partner.filler) {
    return <div className={'level-column-container--wrap'} />
  } else {
    const { img } = partner

    if (partner.href) {
      return (
        <div className={'level-column-container'}>
          <a href={partner.href} target="_blank" rel="noopener noreferrer">
            <img
              src={img.src}
              alt={img.alt}
              width={img.width}
              height={img.height}
              style={img.style}
            />
          </a>
        </div>
      )
    } else {
      return (
        <div className={'level-column-container'}>
          <img src={img.src} alt={img.alt} />
        </div>
      )
    }
  }
}

export default Partners



// WEBPACK FOOTER //
// ./src/Views/Home/Partners.js